import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import { ProjectSelector } from '../components/ProjectSelector';
import { CreateProjectModal } from '../components/CreateProjectModal';
import { ProjectDashboard } from '../components/ProjectDashboard';

export const ProjectsPage: React.FC = () => {
  const { projectId: urlProjectId } = useParams<{ projectId: string }>();
  const navigate = useNavigate();
  const [selectedProjectId, setSelectedProjectId] = useState<number | null>(
    urlProjectId ? parseInt(urlProjectId) : null
  );
  const [selectedProjectName, setSelectedProjectName] = useState<string>('');
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Update selectedProjectId when URL changes
  useEffect(() => {
    if (urlProjectId) {
      setSelectedProjectId(parseInt(urlProjectId));
    } else {
      setSelectedProjectId(null);
    }
  }, [urlProjectId]);

  const handleProjectSelect = (projectId: number, projectName?: string) => {
    navigate(`/projects/${projectId}`);
  };

  const handleCreateNew = () => {
    setIsModalOpen(true);
  };

  const handleProjectCreated = (projectId: number, projectName?: string) => {
    navigate(`/projects/${projectId}`);
  };

  const handleBack = () => {
    navigate('/projects');
  };

  return (
    <Layout
      projectId={selectedProjectId}
      projectName={selectedProjectName}
      onBack={selectedProjectId ? handleBack : undefined}
    >
      {selectedProjectId ? (
        <ProjectDashboard
          projectId={selectedProjectId}
          onBack={handleBack}
        />
      ) : (
        <>
          <ProjectSelector
            onProjectSelect={handleProjectSelect}
            onCreateNew={handleCreateNew}
          />
          <CreateProjectModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            onProjectCreated={handleProjectCreated}
          />
        </>
      )}
    </Layout>
  );
};
